<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="sampleCode"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.sampleName }}</span>
        <br />
        <span>{{ row.sampleNameEn }}</span>
      </template>
      <template v-slot:specInfo="{ row }">
        {{ row.sampleSpec }} {{ row.v_sampleSizeUnit }}
      </template>
      <template v-slot:weightInfo="{ row }">
        {{ row.sampleWeight }} {{ row.v_sampleWeightUnit }}
      </template>
      <template v-slot:moqInfo="{ row }">
        {{ row.moq }} {{ row.v_moqUnit }}
      </template>
      <template v-slot:quotedPriceInfo="{ row }">
        {{ row.quotedPrice }} {{ row.v_quotedCurrency }}
      </template>
      <template v-slot:displaySalesPrice="{ row }">
        <span v-if="row.v_salesType">{{ `${row.v_salesType}：` }}</span>
        <span>{{ row.salesPrice || '0' }}</span>
        <span>{{ row.v_salesCurrency || '' }}</span>
      </template>
      <template v-slot:costPriceInfo="{ row }">
        {{ row.costPrice }} {{ row.v_costCurrency }}
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:sampleStyleNo="{ row }">
        <span>{{ row.sampleStyleNo }}</span>
        <br />
        <span>{{ row.sampleSetNo }}</span>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.sampleStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.sampleStatusName }}
        </el-tag>
      </template>
      <!-- <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { sampleCode: row.sampleCode },
                  query: { sampleStyleNo: row.sampleStyleNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-show="row.sampleStatus === 'Y'"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { sampleCode: row.sampleCode },
                  query: { sampleStyleNo: row.sampleStyleNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
            v-show="row.sampleStatus !== 'N'"
            v-if="allow('C')"
          >
            <i class="el-icon-document-copy tool-btn" @click="copy(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-show="row.sampleStatus === 'S'"
            v-if="allow('I')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { sampleCode: row.sampleCode },
                  query: { sampleStyleNo: row.sampleStyleNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.sampleStatus === 'Y'"
            v-if="allow('D')"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_recovery') || '还原'"
            placement="top"
            v-show="row.sampleStatus === 'N'"
            v-if="allow('R')"
          >
            <i
              class="el-icon-refresh-left tool-btn"
              @click="reduction(row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '审核'"
            placement="top"
            v-show="row.sampleStatus === 'Y'"
            v-if="allow('T')"
          >
            <i class="el-icon-check tool-btn" @click="audit(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.Rejected') || '驳回'"
            placement="top"
            v-if="allow('P') && row.sampleStatus === 'S'"
          >
            <i class="el-icon-close tool-btn" @click="reject(row)"></i>
          </el-tooltip>
        </div>
      </template> -->
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <el-dialog
      width="500px"
      :title="$l('INDEX.form_label_salesman_adjustment') || '业务人员调整'"
      v-if="updateSalePersonVisible"
      :visible.sync="updateSalePersonVisible"
    >
      <el-form
        ref="salesPersonForm"
        :model="salesPersonForm"
        size="medium"
        label-width="100px"
        :rules="personRules"
        style="margin-top: 40px;margin-bottom: 40px;"
      >
        <el-row :gutter="20">
          <el-col :span="22">
            <el-form-item
              :label="$l('INDEX.form_label_business_name') || '业务人员'"
              prop="salesPersonCode"
            >
              <dict-select
                clearable
                v-model="salesPersonForm.salesPersonCode"
                filterable
                size="medium"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_business_person') ||
                    '请选择业务人员'
                "
                :selectedLabel.sync="salesPersonForm.salesPersonName"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button size="small" @click="closeDialog()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="confirm()">{{
          $l('INDEX.product_dialog_btn_confirm') || '确定'
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="500px"
      :title="$l('INDEX.form_label_designer_adjustment') || '设计师调整'"
      v-if="updateDesignerVisible"
      :visible.sync="updateDesignerVisible"
    >
      <el-form
        ref="designerForm"
        :model="designerForm"
        size="medium"
        label-width="100px"
        :rules="designerRules"
        style="margin-top: 40px;margin-bottom: 40px;"
      >
        <el-row :gutter="20">
          <el-col :span="22">
            <el-form-item
              :label="$l('INDEX.form_label_designer') || '设计师'"
              prop="designerCode"
            >
              <dict-select
                clearable
                v-model="designerForm.designerCode"
                filterable
                size="medium"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_designer') ||
                    '请选择设计师'
                "
                :selectedLabel.sync="designerForm.designerName"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button size="small" @click="closeDialog()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="confirmDesigner()">{{
          $l('INDEX.product_dialog_btn_confirm') || '确定'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      updateSalePersonVisible: false,
      updateDesignerVisible: false,
      salesPersonForm: {},
      designerForm: {},
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      personRules: {
        salesPersonCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_a_business_person') ||
              '请选择业务人员',
            trigger: ' change',
          },
        ],
      },
      designerRules: {
        designerCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_designer') ||
              '请选择设计师',
            trigger: ' change',
          },
        ],
      },
    }
  },
  activated() {
    this.removeCheckBox()
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { sampleCode, sampleStyleNo } = data

      switch (menuType) {
        case 'detail':
        case 'edit':
        case 'submitEdit':
          this.$emit('openEditPage', {
            pageType: menuType,
            sampleCode,
          })
          this.openEditPage({
            pageType: menuType,
            params: { sampleCode },
            query: { sampleStyleNo },
          })
          break
        case 'copy':
          this.copy(data)
          break
        case 'delete':
          this.del(data)
          break
        case 'audit':
          this.audit(data)
          break
        case 'reduction':
          this.reduction(data)
          break
        case 'reject':
          this.reject(data)
          break
      }
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'sample-sampleInformation-detail',
        params: { ...params, pageType },
        query,
      })
    },
    del(row) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.sampleInfoDelApi({ sampleCode: row.sampleCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    reduction(row) {
      this.$confirm(
        this.$l('INDEX.tips_question_reduction') || '是否要还原该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .sampleInfoReductionApi({ sampleCode: row.sampleCode })
          .then(() => {
            this.$message({
              showClose: true,
              message:
                this.$l('INDEX.form_label_reduction_succeeded') || '还原成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
    copy(row) {
      this.$confirm(
        this.$l('INDEX.tips_copy') || '是否要复制该样品记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .sampleInfoCopyApi({ sampleCode: row.sampleCode, inputSource: 'PC' })
          .then((res) => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
              type: 'success',
            })
            const { sampleCode, sampleStyleNo } = res.body
            this.openEditPage({
              pageType: 'edit',
              params: { sampleCode },
              query: { sampleStyleNo },
            })
          })
      })
    },
    audit(row) {
      this.$confirm(
        this.$l('INDEX.tips_audit') || '是否要审核该样品记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.sampleInfoAudi(row.sampleCode)
      })
    },
    sampleInfoAudi(sampleCode) {
      this.$api.sampleInfoAuditApi({ sampleCode }).then(() => {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    reject({ sampleCode }) {
      this.$confirm(
        this.$l('INDEX.tips_question_reject') || '是否驳回该审核请求？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .sampleInfoRejectApi({ sampleCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (200 !== status) {
          this.$message.error('驳回失败！')
          return
        }
        this.$message({
          showClose: true,
          message: '驳回成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    exportData() {
      return this.getCheckData()
    },

    updateSalePerson() {
      const param = this.getCheckData()
      if (!param) {
        return
      }
      this.salesPersonForm = {}
      this.updateSalePersonVisible = true
    },

    updateDesigner() {
      const param = this.getCheckData()
      if (!param) {
        return
      }
      this.designerForm = {}
      this.updateDesignerVisible = true
    },

    getCheckData() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())

      if (data.length < 1) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据!!',
          type: 'warning',
        })
        return
      }
      let sampleCodeList = []
      data.forEach((item) => {
        sampleCodeList.push(item.sampleCode)
      })
      let param = {
        sampleCodeList: sampleCodeList,
      }
      return param
    },
    async confirmDesigner() {
      const result = await validate.formValidate([this.$refs.designerForm])
      if (!result) return
      const param = this.getCheckData()
      if (!param) {
        return
      }

      this.$api
        .sampleInfoUpdateDesignerApi({ ...param, ...this.designerForm })
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      this.removeCheckBox()
      this.closeDialog()
    },

    async confirm() {
      const result = await validate.formValidate([this.$refs.salesPersonForm])
      if (!result) return
      const param = this.getCheckData()
      if (!param) {
        return
      }

      this.$api
        .sampleInfoUpdateSalePersonApi({ ...param, ...this.salesPersonForm })
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      this.removeCheckBox()
      this.closeDialog()
    },
    closeDialog() {
      this.updateSalePersonVisible = false
      this.updateDesignerVisible = false
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    removeCheckBox() {
      // 清除选中的记录
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
  },
}
</script>
